const listeners = new Set();

export const emitToast = (type, message) =>
  listeners.forEach((fn) => fn({ type, message: String(message) }));

export const subscribeToast = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};
